"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../lib");

var _common = require("../common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Toggle =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Toggle, _PureComponent);

  function Toggle(props) {
    var _this;

    _classCallCheck(this, Toggle);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Toggle).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "toggleOn", function (e) {
      var active = _this.state.active;

      if (!active) {
        _this.setState({
          active: true
        }, function () {
          var _this$props = _this.props,
              onToggleOn = _this$props.onToggleOn,
              name = _this$props.name;
          onToggleOn(e, {
            name: name,
            value: active
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOff", function (e) {
      var active = _this.state.active;

      if (active) {
        _this.setState({
          active: false
        }, function () {
          var _this$props2 = _this.props,
              onToggleOff = _this$props2.onToggleOff,
              name = _this$props2.name;
          onToggleOff(e, {
            name: name,
            value: active
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function (e) {
      _this.setState(function (prevState) {
        return {
          active: !prevState.active
        };
      }, function () {
        var active = _this.state.active;
        var _this$props3 = _this.props,
            onToggleOn = _this$props3.onToggleOn,
            onToggleOff = _this$props3.onToggleOff,
            onToggle = _this$props3.onToggle,
            name = _this$props3.name;

        if (active) {
          onToggleOn(e, {
            name: name,
            value: active
          });
        } else {
          onToggleOff(e, {
            name: name,
            value: active
          });
        }

        onToggle(e, {
          name: name,
          value: active
        });
      });
    });

    var _active = props.active;
    _this.state = {
      prevProps: {
        active: _active
      },
      active: _active
    };
    return _this;
  }

  _createClass(Toggle, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var active = this.props.active;

      if (prevProps.active !== active) {
        if (active) {
          this.toggleOn();
        } else {
          this.toggleOff();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var active = this.state.active;
      return (0, _lib.getRenderProps)(children, {
        toggleOn: this.toggleOn,
        toggleOff: this.toggleOff,
        toggle: this.toggle,
        active: active
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var active = props.active;
      return {
        // Store the previous props in state
        prevProps: {
          active: active
        },
        active: prevProps.active !== active && state.active === active ? active : state.active
      };
    }
  }]);

  return Toggle;
}(_react.PureComponent);

exports.default = Toggle;

_defineProperty(Toggle, "propTypes", {
  children: _common.customPropTypes.render,
  name: _propTypes.default.string,
  active: _propTypes.default.bool,
  onToggleOn: _propTypes.default.func,
  onToggleOff: _propTypes.default.func,
  onToggle: _propTypes.default.func
});

_defineProperty(Toggle, "defaultProps", {
  children: null,
  name: null,
  active: false,
  onToggleOn: function onToggleOn() {},
  onToggleOff: function onToggleOff() {},
  onToggle: function onToggle() {}
});